<template>
  <div id="app" class="full-page">
    <!-- 页面展示 -->
    <!-- <displayAllPages/> -->
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
// import displayAllPages from './components/displayAllPages.vue'

export default {
  name: 'App',
  components: {
    // displayAllPages
  },
  data() {
    return {
      //
    }
  },
}
</script>

<style lang="less">
.size {
  width: 100%;
  height: 100%;
}

html, body {
  .size;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

#app {
  .size;
}

//#app {
//  font-family: Avenir, Helvetica, Arial, sans-serif;
//  -webkit-font-smoothing: antialiased;
//  -moz-osx-font-smoothing: grayscale;
//  text-align: center;
//  color: #2c3e50;
//  margin-top: 60px;
//}
</style>
